import { CommentIcon } from '../components/icons';
import { cx } from '../components/ui';
import { timecode } from '../lib/format';
import type { Comment } from '../lib/types';

/**
 * Comments drawn along the scrub bar, beside the reactions: where somebody
 * had something to say. Clicking one goes to that moment and opens the
 * comment in the Activity panel.
 */
export function CommentMarkers({
  comments,
  durationSec,
  onOpen,
  className,
}: {
  comments: readonly Comment[];
  durationSec: number;
  onOpen: (comment: Comment) => void;
  className?: string;
}) {
  const timed = comments.filter((comment) => comment.timecodeSec !== null && comment.timecodeSec !== undefined);
  if (timed.length === 0 || !Number.isFinite(durationSec) || durationSec <= 0) return null;
  return (
    <div className={cx('pointer-events-none', className)} role="group" aria-label={`Comments, ${timed.length} on this timeline`}>
      {timed.map((comment) => {
        const at = comment.timecodeSec ?? 0;
        const percent = Math.max(0, Math.min(100, (at / durationSec) * 100));
        const author = comment.authorUser?.name ?? comment.authorName ?? 'Guest';
        return (
          <button
            key={comment.id}
            type="button"
            onClick={() => onOpen(comment)}
            title={`${timecode(at)} · ${author}: ${comment.bodyText.slice(0, 80)}`}
            aria-label={`Comment from ${author} at ${timecode(at)}`}
            className="pointer-events-auto absolute bottom-0 flex -translate-x-1/2 items-end text-chalk drop-shadow-[0_1px_2px_rgba(0,0,0,0.8)] transition-transform duration-120 hover:z-10 hover:scale-125"
            style={{ left: `${percent}%` }}
          >
            <CommentIcon size={13} />
          </button>
        );
      })}
    </div>
  );
}
